export default class Helpers
{
    //this allows us to copy all the variables/ proporties from a generic object to our current object (without haviung to do it manually, one by one)
    //BUG: this will copy all properties from the other object over, not just the ones that should be copied over
    // Object.assign(this, obj);
    //so had to create our own
    static CopyObject(self:any, obj:any)
    {
        // console.log("copying object from: ", obj, "into obj: ", self);
        for (var prop in self) 
        {
            if (obj.hasOwnProperty(prop)) 
            {
                self[prop] = obj[prop];
            }
            // else
            //     console.log("ignoring prop: ", prop, "since obj2 doesn't have prop", obj.hasOwnProperty(prop), " :: ", obj[prop]);
        }
        // console.log("done copying object from: ", obj, "into obj: ", self);
    }
    //going to put it into year, month, day, hour, min, sec
    static DateToHumanReadable(date:Date)
    {
        let str= "";
        if(date)
        {
            str+=date.getFullYear() + "/";
            str+=date.getMonth()+1 + "/";
            str+=date.getDate() + " ";

            // str+= date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
            str+= date.toLocaleTimeString('en-US'); //format: 1:15:30 AM
        }
        return str;
    }

    //from year, month, day, hour, min, sec
    //such as: 2023/5/22 10:25:47 PM


    

    static DateFromHumanReadable(date_time_str:string)
    {
        let date = undefined;
        if(date_time_str&&date_time_str.length>0)
        {
            //create variables for each of the parts
            let [date_str, time_str, am_pm] = [...date_time_str.split(" ")];
            let [year, month, day] = [...date_str.split("/")];
            console.log("DateFromHumanReadable: ", date_str, time_str, am_pm, " date stuff: ", year, month, day)


            let [hours, minutes, seconds] = [...Helpers.GetHoursMinSecsFromTimeString(time_str, am_pm)];
            if(!seconds||seconds==="undefined")
                seconds="0"
            if(!minutes||minutes==="undefined")
                minutes="0"
            if(!hours||hours==="undefined")
                hours="0"

            console.log("DateFromHumanReadable: hours, minutes, seconds", hours, minutes, seconds)

            date = new Date();
            date.setFullYear(parseInt(year));
            date.setMonth(parseInt(month)-1);
            date.setDate(parseInt(day));

            date.setHours(parseInt(hours));
            date.setMinutes(parseInt(minutes));
            date.setSeconds(parseInt(seconds));
        }

        return date;
    }

    //should also support time formats: 10:27 PM/ 12:00pm 16:00/military, or if no time- fill in with 12:00:00 PM
    //should return [hours, minutes, seconds]
    static GetHoursMinSecsFromTimeString(time_str:string, am_pm:string)
    {
        console.log("GetHoursMinSecsFromTimeString, ", time_str, am_pm);
        if(!time_str||time_str==="undefined") //for some reason gets passed as a string "undefined"...
        {
            console.log("!time_str, returning: ", ["12", "00", "00"]);
            return ["12", "00", "00"];
        }
        //default for format: 10:25:47 PM
        // let [hours, minutes, seconds] = [...Helpers.ConvertTime12to24(time_str+" "+am_pm).split(":")];
        let hours="";
        let minutes="";
        let seconds="";

        //check if am/ pm at end of string
        let time_str_caps = time_str.toUpperCase();
        let maybe_am_pm =time_str_caps.slice(time_str_caps.length-2);
        if(maybe_am_pm=="AM"|| maybe_am_pm=="PM")
            am_pm=maybe_am_pm;

        // if(!am_pm)//for military- the convert time should work either way
        // {
        // }

        return [...Helpers.ConvertTime12to24(time_str+" "+am_pm).split(":")]
    }

    //https://stackoverflow.com/questions/15083548/convert-12-hour-hhmm-am-pm-to-24-hour-hhmm
    static ConvertTime12to24 (time12h:string)
     {
        const [time, modifier] = time12h.split(' ');
      
        let [hours, minutes, seconds] = time.split(':');
      
        if (hours === '12') 
          hours = '00';
        
        if(modifier)
            if (modifier.toUpperCase() === 'PM') 
                hours = (parseInt(hours, 10) + 12) +"";

        return `${hours}:${minutes}:${seconds}`;
      }

    static ForceInt(num:any)
    {
        if(isNaN(num))
            num = parseInt(num)
        return num;
    }

}